import { styled } from '@mui/material/styles';
import { MaterialDesignContent } from 'notistack';

/**
 * Modern, minimal toast surface for notistack v3.
 *
 * Instead of the default loud, fully-saturated MUI variants, we render a
 * clean elevated card (matching the app's paper surface) with a thin colored
 * accent bar + tinted icon per variant. Adapts automatically to the active
 * light/dark theme.
 */
export const StyledSnackbarContent = styled(MaterialDesignContent)(({ theme }) => {
  const accentBar = (color) => ({
    borderLeft: `3px solid ${color}`,
    '& svg': { color },
  });

  return {
    '&.notistack-MuiContent': {
      fontFamily: theme.typography.fontFamily,
      fontSize: 13.5,
      fontWeight: 500,
      lineHeight: 1.45,
      letterSpacing: 0,
      padding: '10px 16px',
      borderRadius: 10,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.palette.mode === 'dark'
        ? '0 8px 24px rgba(0, 0, 0, 0.45)'
        : '0 10px 28px rgba(0, 0, 0, 0.12)',
      minWidth: 'auto',
      maxWidth: 420,
      '& #notistack-snackbar': {
        padding: 0,
        gap: 10,
      },
      '& svg': {
        fontSize: 20,
      },
    },
    '&.notistack-MuiContent-success': accentBar(theme.palette.success.main),
    '&.notistack-MuiContent-error': accentBar(theme.palette.error.main),
    '&.notistack-MuiContent-warning': accentBar(theme.palette.warning.main),
    '&.notistack-MuiContent-info': accentBar(theme.palette.info.main),
    '&.notistack-MuiContent-default': accentBar(theme.palette.text.secondary),
  };
});

export default StyledSnackbarContent;
